var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.629,
    height: 20,
    viewBox: "0 0 29.629 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_zocial-email",
    "data-name": "Icon zocial-email",
    d: "M.072,22.3V5.839q0-.029.086-.543l9.686,8.286L.186,22.868A2.421,2.421,0,0,1,.072,22.3ZM1.358,4.154a1.231,1.231,0,0,1,.486-.086H27.929a1.618,1.618,0,0,1,.514.086l-9.714,8.314L17.443,13.5,14.9,15.582,12.358,13.5l-1.286-1.029Zm.029,19.829,9.743-9.343L14.9,17.7l3.771-3.057,9.743,9.343a1.372,1.372,0,0,1-.486.086H1.843a1.294,1.294,0,0,1-.457-.086Zm18.571-10.4L29.615,5.3a1.705,1.705,0,0,1,.086.543V22.3a2.19,2.19,0,0,1-.086.571Z",
    transform: "translate(-0.072 -4.068)",
    fill: "#6bbeec"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail2);
export default __webpack_public_path__ + "static/media/mail2.a850b41db722e09d09655253e13f371c.svg";
export { ForwardRef as ReactComponent };